import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Notes/";
    }

    getClientNotes() {
        return axios.get(this.url + "GetClientNotes");
    }

    createNote(note) {
        return axios.post(this.url + "CreateNote", note);
    }

    editNote(note) {
        return axios.post(this.url + "EditNote", note);
    }

    deleteNote(id) {
        return axios.post(this.url + "DeleteNote", id);
    }

    saveOrder(notes) {
        return axios.post(this.url + "SaveOrder", notes);
    }
}